<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Admin Settings
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Extension Key Allocation</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-puzzle-piece me-1" style="color: #00A0C1;"></i>
                  Allocate extension keys to organisations.
               </small>
            </div>
         </div>
      </div>

      <ExtensionKeyAllocation />
   </div>
</template>

<script>
import ExtensionKeyAllocation from '@/components/Admin Controls/ExtensionKeyAllocation.vue';

export default {
   components: {
      ExtensionKeyAllocation,
   },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>